/**
 *  All api related to system setting
 */

import _ from 'lodash'
import axios from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

// - fetch data bins
export function fetchDataBinsBySlugName({
  slugName,
  params = {},
  ...otherOptions
}) {
  const source = axios.CancelToken.source()
  cancelRequest.add(
    'fetchDataBinsBySlugName',
    () => source.cancel('fetchDataBinsBySlugName: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `data_bins/by_slug_name/${slugName}`,
      method: 'get',
      params,
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      dataBin: data.dataBin
    }))
}

// - update data bins
export function updateDataBinsBySlugName({
  slugName,
  params = {},
  payload = {},
  ...otherOptions
}) {
  const source = axios.CancelToken.source()
  cancelRequest.add(
    'updateDataBinsBySlugName',
    () => source.cancel('updateDataBinsBySlugName: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `data_bins/by_slug_name/${slugName}`,
      method: 'put',
      params,
      data: {
        ...payload
      },
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      dataBin: data.dataBin
    }))
}
